import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '@/lib/api-fetch';
import type { ClientProfile } from '@syfo/types/api.client.types';

/**
 * Update user profile display name
 * @param newName - The new display name to set
 * @returns Updated ClientProfile if successful
 */
export const updateProfileNameThunk = createAsyncThunk<ClientProfile, string>(
  'auth/updateProfileName',
  async (newName: string, { rejectWithValue }) => {
    try {
      const response = await apiFetch('/api/me/name', {
        method: 'PUT',
        headers: {
          'Content-Type': 'text/plain',
        },
        body: newName,
      });

      if (!response.ok) {
        const errorText = await response.text();
        return rejectWithValue(errorText || 'Failed to update profile name');
      }

      const updatedProfile: ClientProfile = await response.json();
      return updatedProfile;
    } catch (error) {
      console.error('[UpdateProfile] Error updating profile name:', error);
      return rejectWithValue(
        error instanceof Error ? error.message : 'Failed to update profile name'
      );
    }
  }
);
